<template>
  <main class="l-main p-register set">
    <div class="l-block">
      <SetLocalNav :hasProject="hasProject" />
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content">
        <div class="hTitle">
          <h1>サイト名を設定して、Google Analytics4を連携します。</h1>
        </div>
        <div class="description">
          <p>サイト名を設定しましょう（後から変更もできます）。</p>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              サイト名
            </p>
          </div>
          <div class="form c-alertPos">
            <Input
              name="projectName"
              v-model="params.projectName"
              placeholder="例: 自社メディアサイト"
              :class="{ alert: isEdited.projectName && error.projectName }"
              @enter="submit"
            />
            <Alert
              v-if="isEdited.projectName && error.projectName"
              class="l-mt-2"
            >
              {{ error.projectName }}
            </Alert>
          </div>
        </div>
        <div class="btnArea">
          <div class="form-auto">
            <Button
              variant="main"
              size="w260"
              fsize="f16"
              icon="arrow_r"
              :class="{ 'is-loading': isProcessing }"
              :disabled="isError || isProcessing"
              @click="submit"
            >
              アカウント認証に進む
            </Button>
          </div>
        </div>
        <Alert v-if="errorResponse" class="l-mt-3">
          {{ errorResponse }}
        </Alert>
      </div>
    </div>
  </main>
</template>

<script>
import { ERROR_MESSAGE } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Progress from '@/components/Progress';
import SetLocalNav from '@/components/set/SetLocalNav';
import TitleRegister from '@/components/TitleRegister';
import utils from '@/utils';
import Validation from '@/validation';
import apiAuthorization from '@/api/authorization';

export default {
  props: ['hasProject'],

  components: {
    Alert,
    Button,
    Input,
    Progress,
    SetLocalNav,
    TitleRegister
  },

  data() {
    return {
      error: {
        projectName: ''
      },
      errorResponse: '',
      params: Object.assign({}, this.$store.state.set.params),
      isEdited: Object.assign({}, this.$store.state.set.isEdited),
      isError: false,
      isProcessing: false,
      progress: [
        {
          current: true,
          label: 'Google Analyticsの登録'
        },
        {
          label: 'Google Search Consoleの登録'
        },
        {
          label: '確認'
        }
      ]
    };
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    params: {
      handler() {
        // 何か入力したらサーバーからのエラーメッセージを消す
        this.errorResponse = '';
      },
      deep: true
    },
    'params.projectName': {
      handler(value, oldValue) {
        this.error.projectName = new Validation()
          .input()
          .test(this.params.projectName.trim());
        if (typeof oldValue !== 'undefined') {
          this.isEdited.projectName = true;
          this.updateParams();
        }
      },
      immediate: true
    }
  },
  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },

    submit() {
      if (this.isError || this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      this.setTmpKey()
        .then(() => {
          this.$store.dispatch('set/setParams', this.params);
          this.$store.dispatch('set/resetGA');
          apiAuthorization.ga.redirect(this.auth.idToken, this.params.tmpKey);
        })
        .catch(error => {
          this.errorResponse = ERROR_MESSAGE.other;
          this.isProcessing = false;
        });
    },

    setTmpKey() {
      return new Promise((resolve, reject) => {
        this.auth
          .getUserData()
          .then(response => {
            let tmpKey = this.params.tmpKey || utils.getTmpKey();

            if (process.env.VUE_APP_ENV === 'local') {
              tmpKey = '7035491964';
            }

            const metaData = response.data.user_metadata;

            // projects内の不要なデータを削除する
            if (metaData.projects) {
              // tmpKeyが同じか、projectIdとprojectNameがあるprojectだけ残す
              metaData.projects = metaData.projects.filter(item => {
                if (
                  item.tmpKey === tmpKey ||
                  (item.projectId && item.projectName)
                ) {
                  return true;
                }
              });
            } else {
              // projectsがなかったら配列を追加する
              metaData.projects = [];
            }

            // projectsにtmpKeyが同じprojectがなかったら、tmpKeyだけの新しいオブジェクトを追加する
            if (!metaData.projects.some(item => item.tmpKey === tmpKey)) {
              metaData.projects.push({
                tmpKey: tmpKey
              });
            }

            const data = {
              user_metadata: metaData
            };

            this.auth
              .updateUserData(data)
              .then(() => {
                this.params.tmpKey = tmpKey;
                resolve();
              })
              .catch(error => {
                reject(error);
              });
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    updateParams() {
      this.$store.dispatch('set/setParams', this.params);
      this.$store.dispatch('set/setEdited', this.isEdited);
    }
  }
};
</script>
